var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmailReminder32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28 20.28a.75.75 0 01-1.06-1.06l4-4a.75.75 0 011.06 1.06l-4 4zM7.21 7.158l8.54 6.642 8.54-6.642a.75.75 0 01.92 1.184l-9 7a.75.75 0 01-.92 0l-9-7a.75.75 0 11.92-1.184zM15.75 22a.75.75 0 010 1.5h-10A2.75 2.75 0 013 20.75v-14A2.75 2.75 0 015.75 4h20a2.75 2.75 0 012.75 2.75v6a.75.75 0 01-1.5 0v-6c0-.69-.56-1.25-1.25-1.25h-20c-.69 0-1.25.56-1.25 1.25v14A1.25 1.25 0 005.75 22h10zm9-5v-.772a1 1 0 011.612-.79l1.965 1.521a1 1 0 010 1.581l-1.965 1.522a1 1 0 01-1.612-.79V18.5h-.5A3.75 3.75 0 1028 22.25a.75.75 0 011.5 0A5.25 5.25 0 1124.25 17h.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailReminder32);
export default __webpack_public_path__ + "static/media/icon-email-reminder-32.47443f96.svg";
export { ForwardRef as ReactComponent };